import {
  refusedExtensions,
  imageExtensions,
  fileExtensions,
  audioExtensions,
  videoExtensions,
  INSTAGRAM_ALLOWED_EXTENSIONS
} from '../components/assets';

export function validationFiles() {
  const VIDEOTYPE = 'video';
  const AUDIOTYPE = 'audio';
  const FILETYPEPDFANDXLSX = 'application';
  const FILETYPECSV = 'text';
  const IMAGETYPE = 'image';

  function formatBytes(bytes) {
    const mb = bytes / 1024 / 1024;
    return `${mb.toFixed(2)} MB`;
  }

  function buildSizeErrorMessage(baseMessage, file, limitBytes) {
    const sentBytes = file.size;

    return (
      `${baseMessage}${file.name} ` +
      `(enviado: ${formatBytes(sentBytes)} / ${sentBytes} bytes; ` +
      `limite: ${formatBytes(limitBytes)} / ${limitBytes} bytes)`
    );
  }

  function CheckedRefusedExtensionsFiles(filesToBeSent) {
    const status = filesToBeSent.some((file) => {
      const fileExtension = file.name.split('.').pop();
      return refusedExtensions.includes(fileExtension);
    });

    return status;
  }

  function isAllFilesWithApprovedExtension(filesToBeSend, channel = null) {
    const MESSAGERETURNINVALIDTYPE = 'Essa extensão de arquivo é inválida';

    let invalidFile = {};
    if (channel === 'instagram') {
      const invalidInstagramFiles =
        CheckedInstagramAllowedExtensions(filesToBeSend);
      if (invalidInstagramFiles) {
        const invalidExtensions = invalidInstagramFiles
          .map((file) => file.name.split('.').pop())
          .join(', ');

        return {
          extension: invalidExtensions,
          message: 'Extensão não permitida no Instagram'
        };
      }
      return {};
    }

    filesToBeSend.forEach((file) => {
      const fileType = file.type.split('/').shift();
      const fileExtension = file.name.split('.').pop();

      if (fileType === VIDEOTYPE && !videoExtensions.includes(fileExtension)) {
        invalidFile = {
          extension: fileExtension,
          message: MESSAGERETURNINVALIDTYPE
        };
      }

      if (fileType === AUDIOTYPE && !audioExtensions.includes(fileExtension)) {
        invalidFile = {
          extension: fileExtension,
          message: MESSAGERETURNINVALIDTYPE
        };
      }

      if (
        (fileType === FILETYPEPDFANDXLSX || fileType === FILETYPECSV) &&
        !fileExtensions.includes(fileExtension)
      ) {
        invalidFile = {
          extension: fileExtension,
          message: MESSAGERETURNINVALIDTYPE
        };
      }

      if (fileType === IMAGETYPE && !imageExtensions.includes(fileExtension)) {
        invalidFile = {
          extension: fileExtension,
          message: MESSAGERETURNINVALIDTYPE
        };
      }
    });

    return invalidFile;
  }

  function sizeInvalidFileValidation(filesToBeSend, to) {
    let sizes = {};

    let invalidSizeFile = {};
    if (to === 'WHATSAPP') {
      sizes = {
        maximumFileSizeVideo: {
          size: 16000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 16MB para: '
        },
        maximumFileSizeAudio: {
          size: 16000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 16MB para: '
        },
        maximumFileSizeImage: {
          size: 5242880,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 5MB para: '
        },
        maximumFileSizePDF: {
          size: 100000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 100MB para: '
        },
        maximumFileSizeImageAnyValidMimeType: {
          size: 50000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 50MB para: '
        }
      };
    } else if (to === 'INSTAGRAM') {
      sizes = {
        maximumFileSizeVideo: {
          size: 25000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 25MB para vídeos do Instagram: '
        },
        maximumFileSizeAudio: {
          size: 25000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 25MB para áudios do Instagram: '
        },
        maximumFileSizeImage: {
          size: 8000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 8MB para imagens do Instagram: '
        }
      };
    } else {
      sizes = {
        maximumFileSizeVideo: {
          size: 16000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 16MB para: '
        },
        maximumFileSizeAudio: {
          size: 16000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 16MB para: '
        },
        maximumFileSizeImage: {
          size: 50000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 5MB para: '
        },
        maximumFileSizeImageAnyValidMimeType: {
          size: 100000000,
          message:
            'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 100MB para: '
        }
      };
    }

    filesToBeSend.forEach((file) => {
      const fileType = file.type.split('/').shift();

      if (
        fileType === VIDEOTYPE &&
        file.size > sizes.maximumFileSizeVideo.size
      ) {
        const limitBytes = sizes.maximumFileSizeVideo.size;

        invalidSizeFile = {
          extension: fileType,
          fileName: file.name,
          sizeBytes: file.size,
          limitBytes,
          message: buildSizeErrorMessage(
            sizes.maximumFileSizeVideo.message,
            file,
            limitBytes
          )
        };
      }

      if (
        fileType === AUDIOTYPE &&
        file.size > sizes.maximumFileSizeAudio.size
      ) {
        const limitBytes = sizes.maximumFileSizeAudio.size;

        invalidSizeFile = {
          extension: fileType,
          fileName: file.name,
          sizeBytes: file.size,
          limitBytes,
          message: buildSizeErrorMessage(
            sizes.maximumFileSizeAudio.message,
            file,
            limitBytes
          )
        };
      }

      if (
        fileType === IMAGETYPE &&
        file.size > sizes.maximumFileSizeImage.size
      ) {
        const limitBytes = sizes.maximumFileSizeImage.size;

        invalidSizeFile = {
          extension: fileType,
          fileName: file.name,
          sizeBytes: file.size,
          limitBytes,
          message: buildSizeErrorMessage(
            sizes.maximumFileSizeImage.message,
            file,
            limitBytes
          )
        };
      }

      if (
        fileType !== IMAGETYPE &&
        fileType !== AUDIOTYPE &&
        fileType !== VIDEOTYPE &&
        file.size > sizes.maximumFileSizeImageAnyValidMimeType.size
      ) {
        const limitBytes = sizes.maximumFileSizeImageAnyValidMimeType.size;

        const baseMessage =
          sizes.maximumFileSizeImageAnyValidMimeType.message ||
          'Erro ao enviar arquivo(s). Tamanho máximo deve ser de 100MB para: ';

        invalidSizeFile = {
          extension: fileType,
          fileName: file.name,
          sizeBytes: file.size,
          limitBytes,
          message: buildSizeErrorMessage(baseMessage, file, limitBytes)
        };
      }
    });

    return invalidSizeFile;
  }

  function isFilesWithApprovedExtension(filesToBeSent) {
    const EXTENSIONVALID = 'pdf';
    const files = filesToBeSent.filter((file) => {
      const fileExtension = file.name.split('.').pop();
      return fileExtension === EXTENSIONVALID;
    });

    return files;
  }

  function isImagesWithApprovedExtension(filesToBeSent) {
    const images = filesToBeSent.filter((image) => {
      const imageExtension = image.name.split('.').pop();
      return imageExtensions.includes(imageExtension);
    });

    return images;
  }

  function CheckedInstagramAllowedExtensions(filesToBeSent) {
    const invalidFiles = filesToBeSent.filter((file) => {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      return !INSTAGRAM_ALLOWED_EXTENSIONS.includes(fileExtension);
    });

    return invalidFiles.length > 0 ? invalidFiles : false;
  }

  return {
    CheckedRefusedExtensionsFiles,
    isAllFilesWithApprovedExtension,
    isFilesWithApprovedExtension,
    isImagesWithApprovedExtension,
    sizeInvalidFileValidation,
    CheckedInstagramAllowedExtensions
  };
}
